import { render } from "./goodsManage.vue?vue&type=template&id=62ae5dc4"
import script from "./goodsManage.vue?vue&type=script&lang=jsx"
export * from "./goodsManage.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__